module.exports = __webpack_public_path__ + "img/Piece-18-1.b7e24337.png";